import * as TP from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCarrierConnectCompanyAndUserTenantRelationshipsQueryVariables = TP.Exact<{
  startIndex: TP.Scalars['Int'];
  pageSize: TP.Scalars['Int'];
  endIndex: TP.Scalars['Int'];
}>;


export type GetCarrierConnectCompanyAndUserTenantRelationshipsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getCarrierConnectCompanyAndUserTenantRelationships: (
    { readonly __typename?: 'UserCompanyPayload' }
    & { readonly company?: TP.Maybe<(
      { readonly __typename?: 'CompanyOutput' }
      & Pick<TP.CompanyOutput, 'companyId' | 'companyName'>
    )>, readonly companyRelationships?: TP.Maybe<ReadonlyArray<(
      { readonly __typename?: 'CompanyDetailsOutput' }
      & Pick<TP.CompanyDetailsOutput, 'companyId' | 'tenantId' | 'mmApprovedRecordIds' | 'mmRecordId' | 'tenantName' | 'tenantCode'>
    )>>, readonly userTenantRelationships?: TP.Maybe<(
      { readonly __typename?: 'UserTenantRelationshipsOutput' }
      & Pick<TP.UserTenantRelationshipsOutput, 'endIndex' | 'pageSize' | 'resultCount' | 'startIndex'>
      & { readonly relationships?: TP.Maybe<ReadonlyArray<(
        { readonly __typename?: 'UserTenantRelationshipOutput' }
        & Pick<TP.UserTenantRelationshipOutput, 'createdDate' | 'displayName' | 'isActive' | 'tenantCode' | 'tenantId' | 'tenantName' | 'type' | 'userId'>
      )>> }
    )>, readonly errors?: TP.Maybe<ReadonlyArray<(
      { readonly __typename?: 'CarrierConnectError' }
      & Pick<TP.CarrierConnectError, 'message' | 'code'>
    )>> }
  ) }
);


export const GetCarrierConnectCompanyAndUserTenantRelationshipsDocument = gql`
    query GetCarrierConnectCompanyAndUserTenantRelationships($startIndex: Int!, $pageSize: Int!, $endIndex: Int!) {
  getCarrierConnectCompanyAndUserTenantRelationships(
    startIndex: $startIndex
    pageSize: $pageSize
    endIndex: $endIndex
  ) {
    company {
      companyId
      companyName
    }
    companyRelationships {
      companyId
      tenantId
      mmApprovedRecordIds
      mmRecordId
      tenantName
      tenantCode
    }
    userTenantRelationships {
      endIndex
      pageSize
      relationships {
        createdDate
        displayName
        isActive
        tenantCode
        tenantId
        tenantName
        type
        userId
      }
      resultCount
      startIndex
    }
    errors {
      message
      code
    }
  }
}
    `;

/**
 * __useGetCarrierConnectCompanyAndUserTenantRelationshipsQuery__
 *
 * To run a query within a React component, call `useGetCarrierConnectCompanyAndUserTenantRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarrierConnectCompanyAndUserTenantRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarrierConnectCompanyAndUserTenantRelationshipsQuery({
 *   variables: {
 *      startIndex: // value for 'startIndex'
 *      pageSize: // value for 'pageSize'
 *      endIndex: // value for 'endIndex'
 *   },
 * });
 */
export function useGetCarrierConnectCompanyAndUserTenantRelationshipsQuery(baseOptions: Apollo.QueryHookOptions<GetCarrierConnectCompanyAndUserTenantRelationshipsQuery, GetCarrierConnectCompanyAndUserTenantRelationshipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarrierConnectCompanyAndUserTenantRelationshipsQuery, GetCarrierConnectCompanyAndUserTenantRelationshipsQueryVariables>(GetCarrierConnectCompanyAndUserTenantRelationshipsDocument, options);
      }
export function useGetCarrierConnectCompanyAndUserTenantRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarrierConnectCompanyAndUserTenantRelationshipsQuery, GetCarrierConnectCompanyAndUserTenantRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarrierConnectCompanyAndUserTenantRelationshipsQuery, GetCarrierConnectCompanyAndUserTenantRelationshipsQueryVariables>(GetCarrierConnectCompanyAndUserTenantRelationshipsDocument, options);
        }
export type GetCarrierConnectCompanyAndUserTenantRelationshipsQueryHookResult = ReturnType<typeof useGetCarrierConnectCompanyAndUserTenantRelationshipsQuery>;
export type GetCarrierConnectCompanyAndUserTenantRelationshipsLazyQueryHookResult = ReturnType<typeof useGetCarrierConnectCompanyAndUserTenantRelationshipsLazyQuery>;
export type GetCarrierConnectCompanyAndUserTenantRelationshipsQueryResult = Apollo.QueryResult<GetCarrierConnectCompanyAndUserTenantRelationshipsQuery, GetCarrierConnectCompanyAndUserTenantRelationshipsQueryVariables>;